module.exports = __webpack_public_path__ + "static/Wikigrads-12bdd5fc650d6f8d164556d1828eb629.png";